import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const formElementContainer = ({
  theme,
  isDragging,
  isActive,
}: {
  theme: Theme
  isDragging?: boolean
  isActive?: boolean
}) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 4px 8px 16px 8px;
  background-color: ${theme.palette.background.paper};
  transform: ${isActive ? 'translateX(40px)' : 'translateX(0px)'} !important;
  ${isDragging
    ? css`
        opacity: 0;
        cursor: grabbing;
      `
    : ''}
`
